import styled, { css } from 'styled-components';

export const BUTTON_STYLE = { padding: '0px 40px' };

export const Container = styled.div`
  padding: 0 24px;
  height: 100%;
`;

export const ContentContainer = styled.div`
  overflow-y: scroll;
  // 64px size of the sidePanel footer + 2px for Divider  // 24px margin size design wanted between divider and footer
  height: calc(100% - (64px + 2px + 24px));
  padding: 24px 0px;
`;

export const TitleContainer = styled.div`
  font: ${(props) => props.theme.fonts.h1InterNonBold};
  color: ${(props) => props.theme.colors.greys.darkest};
`;

export const Content = styled.div`
  height: ${({ height }) => height};
  padding: 24px 0px;
`;

export const Divider = styled.div`
  border: 1px solid;
  border-color: ${(props) => props.theme.colors.greys.light};
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const DetailContainer = styled.div`
  display: grid;

  margin-top: 24px;
  gap: 8px;
`;

export const RequiredTextContainer = styled.div`
  display: flex;

  margin-top: 12px;
  margin-bottom: 8px;
`;

export const EmptyStateContainer = styled.div`
  display: grid;

  margin-top: 96px;
  gap: 8px;

  justify-items: center;

  ${({ inline }) =>
    inline &&
    css`
      display: flex;
      flex-direction: row;
    `};
`;

export const DrawerText = styled.div`
  display: flex;
  align-items: center;

  font: ${({ theme, isBold }) =>
    isBold ? theme.colors.greys.darkest : theme.fonts.textMiddleNormal};
  color: ${({ theme }) => theme.colors.greys.darkest};
`;

export const DropdownItem = styled.div`
  width: 100%;
  padding: 12px 0px;
  display: flex;
  flex-direction: row;
`;

export const DropdownItemImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const DropdownItemValuesContainer = styled.div`
  overflow: hidden;
  padding-left: 8px;
  max-width: 264px;
`;

export const DropdownItemMainValue = styled.div`
  font: ${(props) => props.theme.fonts.textMiddleNormal};
  margin-bottom: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const DropdownItemSecondaryValue = styled.div`
  font: ${(props) => props.theme.fonts.textSmallHeight16};
  color: ${(props) => props.theme.colors.greys.dark};
  margin-top: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${(props) =>
    props.isDisabled &&
    css`
      color: ${props.theme.colors.greys.light};
    `};
`;

export const InputIncrementContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  justify-content: start;
`;

export const TotalsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-top: 24px;
  gap: 24px;
`;

export const TotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 4px;
`;
